module.exports = __webpack_public_path__ + "static/media/banner.a5d8f60d.png";